"use client";

import { createContext, useContext, useMemo } from "react";

/**
 * @typedef {object} ThemeContextValue
 * @prop {string} theme
 */

/** @type {ThemeContextValue} */
const DEFAULT_VALUES = {
  theme: "cloudspire",
};

const ThemeContext = createContext(DEFAULT_VALUES);

export function useTheme() {
  const value = useContext(ThemeContext);

  if (value === DEFAULT_VALUES) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }

  return value;
}

/**
 * @typedef {object} Props
 * @prop {string} [theme]
 * @prop {React.ReactNode} children
 */
/**
 * @param {Props} props
 */
export function ThemeProvider({ children, theme = "cloudspire" }) {
  const value = useMemo(() => {
    const value = {
      theme,
    };
    return value;
  }, [theme]);

  return (
    <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>
  );
}
